
export const StripeProductTypes = {
  LICENSE: "LICENSE",
  NFT: "NFT"
}